function cov_17s01g2xr6() {
  var path = "/__w/code/code/js/packages/bricks/src/hooks/useOutsideClickAlerter.ts";
  var hash = "4ea56134c35ebe05112922639e3dda9ed409ed48";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/hooks/useOutsideClickAlerter.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 38
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 19,
          column: 28
        }
      },
      "2": {
        start: {
          line: 7,
          column: 31
        },
        end: {
          line: 11,
          column: 5
        }
      },
      "3": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 10,
          column: 7
        }
      },
      "4": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 9,
          column: 25
        }
      },
      "5": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 63
        }
      },
      "6": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "7": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 38
          },
          end: {
            line: 3,
            column: 39
          }
        },
        loc: {
          start: {
            line: 3,
            column: 63
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 18
          },
          end: {
            line: 6,
            column: 19
          }
        },
        loc: {
          start: {
            line: 6,
            column: 24
          },
          end: {
            line: 19,
            column: 3
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 7,
            column: 31
          },
          end: {
            line: 7,
            column: 32
          }
        },
        loc: {
          start: {
            line: 7,
            column: 50
          },
          end: {
            line: 11,
            column: 5
          }
        },
        line: 7
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 15,
            column: 11
          },
          end: {
            line: 15,
            column: 12
          }
        },
        loc: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 10,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 10,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 10
          },
          end: {
            line: 8,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 10
          },
          end: {
            line: 8,
            column: 21
          }
        }, {
          start: {
            line: 8,
            column: 25
          },
          end: {
            line: 8,
            column: 64
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4ea56134c35ebe05112922639e3dda9ed409ed48"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17s01g2xr6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17s01g2xr6();
import React from 'react';
cov_17s01g2xr6().s[0]++;
export const useOutsideClickAlerter = (ref, onClickOutside) => {
  cov_17s01g2xr6().f[0]++;
  cov_17s01g2xr6().s[1]++;
  // Custom hook that listens when a click occurs outside the target ref.
  // Useful for "custom" dropdowns/pop-over type components.
  React.useEffect(() => {
    cov_17s01g2xr6().f[1]++;
    cov_17s01g2xr6().s[2]++;
    const handleClickOutside = e => {
      cov_17s01g2xr6().f[2]++;
      cov_17s01g2xr6().s[3]++;
      if ((cov_17s01g2xr6().b[1][0]++, ref.current) && (cov_17s01g2xr6().b[1][1]++, !ref.current.contains(e.target))) {
        cov_17s01g2xr6().b[0][0]++;
        cov_17s01g2xr6().s[4]++;
        onClickOutside();
      } else {
        cov_17s01g2xr6().b[0][1]++;
      }
    };

    // Bind the event listener
    cov_17s01g2xr6().s[5]++;
    document.addEventListener('mousedown', handleClickOutside);
    cov_17s01g2xr6().s[6]++;
    return () => {
      cov_17s01g2xr6().f[3]++;
      cov_17s01g2xr6().s[7]++;
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside]);
};